import {
  CLEAR_PLANNER,
  UPDATE_PLANNER,
  PLANNER_LINES,
  PLANNER_LINES_CLEAR,
  PLANNER_TASKS,
  PLANNER_TASKS_CLEAR,
  PLANNER_MEMOS,
  PLANNER_MEMOS_CLEAR,
  PLANNER_TASKABLES,
  PLANNER_TASKABLES_CLEAR,
  PLANNER_LOCATIONS,
  PLANNER_LOCATIONS_CLEAR,
  PLANNER_SCHEDULES,
  PLANNER_SCHEDULES_CLEAR,
  PLANNER_ORDERS,
  PLANNER_ORDERS_CLEAR
} from '../action_types';
import { deepmerge } from 'utilities/merge';
export const planner = function(state = {}, action) {
  switch ( action.type ) {
    case UPDATE_PLANNER:
      // let timestamp = new Date().getTime();
      // console.log('UPDATE_PLANNER started_at: ', timestamp)
      App.setCurrentPayload({planner: action.payload})
      let data = deepmerge(state, action.payload);
      // console.log('UPDATE_PLANNER done_at: ', timestamp - new Date().getTime());
      return data;
    case CLEAR_PLANNER:
      return {};
    default:
      return state;
  }
};
export const lines = function(state = {}, action) {
  switch ( action.type ) {
    case PLANNER_LINES:
      App.setCurrentPayload({lines: action.payload})
      return Object.assign({}, state, action.payload);
      // return deepmerge(state, action.payload);
    case PLANNER_LINES_CLEAR:
      return {};
    default:
      return state;
  }
};
export const tasks = function(state = {}, action) {
  switch ( action.type ) {
    case PLANNER_TASKS:
      App.setCurrentPayload({tasks: action.payload})
      return Object.assign({}, state, action.payload);
      // return deepmerge(state, action.payload);
    case PLANNER_TASKS_CLEAR:
      return {};
    default:
      return state;
  }
};
export const memos = function(state = {}, action) {
  switch ( action.type ) {
    case PLANNER_MEMOS:
      App.setCurrentPayload({memos: action.payload})
      return Object.assign({}, state, action.payload);
      // return deepmerge(state, action.payload);
    case PLANNER_MEMOS_CLEAR:
      return {};
    default:
      return state;
  }
};
export const taskables = function(state = {}, action) {
  switch ( action.type ) {
    case PLANNER_TASKABLES:
      App.setCurrentPayload({taskables: action.payload})
      return Object.assign({}, state, action.payload);
      // return deepmerge(state, action.payload);
    case PLANNER_TASKABLES_CLEAR:
      return {};
    default:
      return state;
  }
};
export const locations = function(state = {}, action) {
  switch ( action.type ) {
    case PLANNER_LOCATIONS:
      App.setCurrentPayload({locations: action.payload})
      return Object.assign({}, state, action.payload);
      // return deepmerge(state, action.payload);
    case PLANNER_LOCATIONS_CLEAR:
      return {};
    default:
      return state;
  }
};
export const schedules = function(state = {}, action) {
  switch ( action.type ) {
    case PLANNER_SCHEDULES:
      // return Object.assign({}, state, action.payload);
      App.setCurrentPayload({schedules: action.payload})
      return deepmerge(state, action.payload);
    case PLANNER_LOCATIONS_CLEAR:
      return {};
    default:
      return state;
  }
};
export const orders = function(state = {}, action) {
  switch ( action.type ) {
    case PLANNER_ORDERS:
      App.setCurrentPayload({orders: action.payload})
      return deepmerge(state, action.payload);
    case PLANNER_ORDERS_CLEAR:
      return {};
    default:
      return state;
  }
};
